
<template>
    <div class="conference_data">
        
        <div class="time_block mt-2  pb-5">
            <date-picker
                value-type="format"
                v-model="selected_date"
                :lang="d_lang"
                @change="getItems"
                :clearable="false"
                :first-day-of-week="1"
            >
            </date-picker>
        </div>
        
        <b-overlay :show="is_load">
            <div class="conf_type" v-for="conf in items">
                <conference_type @change="work_item" :cur_item="conf"></conference_type>
            </div>
        </b-overlay>
        
        
        <div class="conference_info active" v-if="selected_items.length > 0">
            <div class="fio mb-5 mt-5">
                <div class="form-group">
                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="fal fa-user fs-xl"></i></span>
                        </div>
                        
                        <b-form-input class="fs-xl"
                                      placeholder="Введіть ФІО"
                                      :state="send_form.user_data.length > 0"
                                      v-model="send_form.user_data"
                                      maxlength="30" id="doc_title"
                                      size="sm" >
                        </b-form-input>
                    </div>
                </div>
            </div>
            
            <div class="coment form-group">
                <b-textarea rows="5" cols="4" v-model="send_form.comment"></b-textarea>
            </div>
            
            <div class="make_conf w-25">
                <button type="button"  v-on:click="save_reservation" :disabled="!can_send"
                        class="conf_select btn btn-lg btn-outline-primary waves-effect waves-themed active">
                    
                    <span class="fal  mr-1"
                          :class="{ 'fa-check': can_send, 'fa-exclamation-triangle': !can_send }">
                    </span>
                    Забронювати
                </button>
            </div>
        </div>
        
        <conference_modal @reload="getItems"></conference_modal>
    </div>
</template>

<script >

import conference_type from "./conference_type/conference_type.vue";
import Conference_modal from "./conference_modal/conference_modal.vue";
import DatePicker from 'vue2-datepicker'

export default {
    components : {
        Conference_modal,
        conference_type,
        DatePicker
    },
    
    name: "conference",
    data() {
        return {
            items  : [],
            is_load : false,
            selected_date : moment().format('YYYY-MM-DD'),
            send_form : {
                "comment" : "",
                "user_data" : "",
            }
        }
    },
    
    created() {
        this.getItems();
    },
    
    mounted() {
    
    },
    
    methods: {
        work_item(item,type) {
            console.log('on_change',type,item);
            
            if(item.class == 'free') {
                item.is_selected = !item.is_selected;
            }
            
            if(item.class == 'zanyat') {
                EventBus.$emit('show_conference_info',item.item);
            }
        },
        
        async getItems() {
            this.is_load = true;
            this.items = [];
            
            await api.post('/conference/',{
                "date" : this.selected_date
            }).then(({data}) => {
                this.is_load = false;
                if (data.status == "operation_success") {
                    this.selected_date = data.message;
                    data.data.map(item => {
                        item.items.map(inside_item => {
                            inside_item.is_selected = false;
                        });
                        this.items.push(item);
                    });
                }
            }).catch(err => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err:err.message ,type:"danger",title:err.name})
            });
        },
        
        async save_reservation()
        {
            this.is_load = true;
            await api.put('/conference',{
                "form" : this.send_form,
                "items" : this.selected_items
            }).then(({data}) => {
                if (data.status == "operation_success") {
                    this.getItems();
                }
            }).catch(err => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err:err.message ,type:"danger",title:err.name})
            });
        }
        
    },
    computed: {
        
        d_lang() {
            return this.get_datepickLang();
        },
        
        
        selected_items () {
            let items = [];
            this.items.map(group => {
                if (group.hasOwnProperty("items")) {
                    group.items.map(item_block => {
                        if (item_block.is_selected) {
                            items.push({
                                "group": group.type,
                                "item": item_block
                            })
                        }
                    });
                }
            });
            
            return items;
        },
        
        can_send() {
            if(this.send_form.user_data.length > 0 && this.selected_items.length > 0) {
                return true;
            }
            
            return false;
        }
    },
}
</script>


<style scoped>
    .conference_data {
        min-height: 200px;
    }
</style>